import modals from "./modals";
import valutes from "./valutes";
import reviews from "./reviews";
import reserve from "./reserve";
import auth from "./auth";
import transaction from "./transaction";
import info from "./info";
import chat from "./chat";
import cabinet from "./cabinet";

export default {
  modals,
  valutes,
  reviews,
  reserve,
  auth,
  transaction,
  info,
  chat,
  cabinet
};



// WEBPACK FOOTER //
// ./src/store/modules/index.js